<template>
  <div class="popUpWrap">
    <section class="popup light">
      <div class="topArea">
        <h4>{{ t("profile-about-me") }}</h4>
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <ul class="infoList flex">
          <li class="flex">
            <div class="tit">{{ t("profile-title") }}</div>
            <input
              id="aboutMeTitleEditInput"
              v-model="title"
              type="text"
              :class="{error: !isValidStringTitle}"
              :placeholder="t('profile-title-placeholder')">
            <p v-if="!isValidStringTitle" class="errorMessage"><span></span>{{ t("profile-title-error") }}</p>
          </li>
          <li class="flex">
            <div class="tit">{{ t("profile-content") }}</div>
            <textarea
              id="aboutMeContentEditInput"
              v-model="content"
              :class="{error: !isValidStringContent}"
              :placeholder="t('profile-content-placeholder')"
              style="height: 244px;" />
            <p v-if="!isValidStringContent" class="errorMessage"><span></span>{{ t("profile-content-error") }}</p>
          </li>
        </ul>
        <div class="btnArea">
          <button
            v-if="id !== 0"
            class="btn cancel"
            @click.stop="onClickOpenDeletePopup"
          >
            <span></span>
            {{ t("common-delete") }}
          </button>
          <button
            id="aboutMeSaveButton"
            class="btn"
            :class="{ disabled: !isValidDisableButton }"
            :disabled="!isValidDisableButton"
            @click.stop="onClickSave"
          >
            {{ t("common-save") }}
          </button>
        </div>
      </div>
    </section>
    <div v-if="isOpenDeletePopup" class="popUpWrap">
      <section class="popup dark basic">
        <div class="topArea">
          <div class="exit" @click.stop="isOpenDeletePopup = false"></div>
        </div>
        <div class="scrollY">
          <h5>{{ t('profile-about-me-delete') }}</h5>
          <div class="btnArea">
            <button class="cancel" @click.stop="isOpenDeletePopup = false">{{ t("common-cancel") }}</button>
            <button @click.stop="onClickDelete">{{ t("common-delete") }}</button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useDialogStore } from "~/store/dialog/dialogStore";
import { onMounted } from "#imports";
import { useToastStore } from "~/store/toast/toastStore";
import { ToastType } from "~/components/Common/Toast/model/ToastType";
import { useProfileService } from "~~/application/composables/service/useProfileService";

const { t } = useI18n();

const dialogStore = useDialogStore();
const toastStore = useToastStore();
const profileService = useProfileService()

const id = ref(0);
const title = ref("");
const content = ref("");
const isOpenDeletePopup = ref(false);

onMounted(() => {
  id.value = dialogStore.options.props.id;
  title.value = dialogStore.options.props.title;
  content.value = dialogStore.options.props.content;
})

const isValidStringTitle = computed(() => {
  return title.value.length <= 50;
});

const isValidStringContent = computed(() => {
  return content.value.length <= 1500;
});

const isValidDisableButton = computed(() => {
  return title.value.length > 0 && content.value.length > 0 && isValidStringTitle.value && isValidStringContent.value
})

const onClickSave = () => {
  if(id.value === 0){
    profileService.addAboutMe(title.value, content.value).then(response => {
      if(response){
        toastStore.openToast({
          toastType: ToastType.SUCCESS,
          contents: t(`profile-change-success`)
        })
        dialogStore.options.confirm?.event();
        onClickClose();
      }
      else {
        toastStore.openToast({
          toastType: ToastType.FAILED,
          contents: t(`profile-change-fail`)
        })
      }
    }).catch(() => {
      toastStore.openToast({
        toastType: ToastType.FAILED,
        contents: t(`profile-change-fail`)
      })
    })
  }
  else {
    profileService.modifyAboutMe(id.value, title.value, content.value).then(response => {
      if(response){
        toastStore.openToast({
          toastType: ToastType.SUCCESS,
          contents: t(`profile-change-success`)
        })

        dialogStore.options.confirm?.event();
        onClickClose();
      }
      else {
        toastStore.openToast({
          toastType: ToastType.FAILED,
          contents: t(`profile-change-fail`)
        })
      }
    }).catch(() => {
      toastStore.openToast({
        toastType: ToastType.FAILED,
        contents: t(`profile-change-fail`)
      })
    })
  }
}

const onClickOpenDeletePopup = () => {
  isOpenDeletePopup.value = true;
};

const onClickDelete = () => {
  isOpenDeletePopup.value = false;
  profileService.deleteAboutMe(id.value).then(response => {
    if (response) {
      toastStore.openToast({
        toastType: ToastType.SUCCESS,
        contents: t(`profile-about-me-delete-success`)
      });
      dialogStore.options.confirm?.event();
      onClickClose();
    } else {
      toastStore.openToast({
        toastType: ToastType.FAILED,
        contents: t(`profile-about-me-delete-fail`)
      });
    }
  }).catch(() => {
    toastStore.openToast({
      toastType: ToastType.FAILED,
      contents: t(`profile-about-me-delete-fail`)
    });
  });
}

const onClickClose = () => {
  dialogStore.close();
};
</script>

